import styled from "styled-components";

export const MessageErrorComponent = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.danger};
`;
